import type { PlayerProvince, PlayRequestStatus } from './players.model';

/**
 * Las 7 provincias del filtro del directorio, verbatim y en el orden de
 * `App\Support\CostaRicaLocations` (`perronstore-api`, `d60c953`): el slug es lo que
 * viaja en `?province=` y el nombre, lo que se pinta. Sin cantón (la API no lo filtra).
 */
export const PLAYER_PROVINCES: readonly PlayerProvince[] = [
  { slug: 'san-jose', name: 'San José' },
  { slug: 'alajuela', name: 'Alajuela' },
  { slug: 'cartago', name: 'Cartago' },
  { slug: 'heredia', name: 'Heredia' },
  { slug: 'guanacaste', name: 'Guanacaste' },
  { slug: 'puntarenas', name: 'Puntarenas' },
  { slug: 'limon', name: 'Limón' },
];

/**
 * Espejo de `PlayersCopy::CONSENT_VERSION` (B9, B31). Cambia cuando cambia el texto de
 * consentimiento (`PLAYERS_COPY.consent`), y los dos lados a la vez.
 */
export const PLAYERS_CONSENT_VERSION = '2026-10-v1';

/** Sección 12 de la Política de privacidad v1.1 (N25 del spec de la API). */
export const PLAYERS_PRIVACY_PATH = '/privacidad';
export const PLAYERS_PRIVACY_FRAGMENT = 'directorio-de-jugadores-y-solicitudes-para-jugar';

/** Pestaña «Comunidad» del perfil (contrato W0a de B10 §5.5). */
export const PLAYERS_PROFILE_PATH = '/perfil/comunidad';

/** Enlace de «reportar» (B26): no hay botón, se escribe a la tienda. */
export const PLAYERS_CONTACT_PATH = '/contacto';

/** Espera mínima del botón «Reenviar correo de verificación» tras cada intento (B10 B24). */
export const PLAYERS_RESEND_COOLDOWN_S = 60;

/** Los 6 `STATUSES` de `App\Models\PlayRequest`, en su orden (filtro del historial, D33). */
export const PLAY_REQUEST_STATUSES: readonly PlayRequestStatus[] = [
  'pendiente',
  'aceptada',
  'rechazada',
  'cancelada',
  'caducada',
  'cerrada',
];

/** Tope de `message` de una solicitud (`PlayRequest::MESSAGE_MAX`). */
export const PLAY_REQUEST_MESSAGE_MAX = 280;

/** Espera tras un 429 de envío si `Retry-After` no se puede leer. */
export const PLAY_REQUEST_RETRY_FALLBACK_S = 60;
